import { render, staticRenderFns } from "./AdminManageTravel.vue?vue&type=template&id=7ad9640c"
import script from "./AdminManageTravel.vue?vue&type=script&lang=js"
export * from "./AdminManageTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports